import cn from "classnames"
import Image from "components/Image"
import LazyVideo from "components/LazyVideo"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function HeaderVideo({ blok }) {
  return (
    <section className="relative h-44 w-full md:h-60">
      {blok.video.filename || blok.video_fallback.filename ? (
        <LazyVideo
          className="pointer-events-none relative hidden w-full object-cover md:block md:h-60"
          poster={blok.large_screen_image.filename}
          sources={[
            { src: blok.video.filename, type: "video/mp4; codecs=av01.0.04M.10" },
            { src: blok.video_fallback.filename, type: "video/mp4" },
          ]}
          autoPlay
          playsInline
          muted
          loop
        />
      ) : (
        <Image
          loader={storyblokImageLoader}
          src={blok?.large_screen_image?.filename ?? "https://via.placeholder.com/3840x2160"}
          alt={blok?.large_screen_image?.alt ?? null}
          priority
          fill
          className={cn("object-cover", { "hidden md:block": blok?.small_screen_image?.filename })}
        />
      )}
      <>
        {blok?.small_screen_image?.filename ? (
          <Image
            loader={storyblokImageLoader}
            src={blok?.small_screen_image?.filename ?? "https://via.placeholder.com/3840x2160"}
            alt={blok?.small_screen_image?.alt ?? null}
            priority
            fill
            className="object-cover md:hidden"
          />
        ) : null}
      </>
    </section>
  )
}
